<div
  class="upload-video flex-col justify-center align-center"
  [ngClass]="{ 'upload-video--uploaded': previewUrl }"
>
  <ng-container *ngIf="previewUrl; else uploadInput">
    <div class="upload-video__uploaded">
      <div class="upload-video__close">
        <img
          src="assets/images/close.svg"
          alt=""
          (click)="handleRemoveVideo()"
        />
      </div>
      <video width="320" height="240" controls controlslist="nodownload">
        <source [src]="previewUrl" />
        Your browser does not support the video tag.
      </video>
    </div>
  </ng-container>
</div>
<ng-template #uploadInput>
  <ng-container *ngIf="!videoUploading; else progress">
    <input
      title=""
      type="file"
      (change)="onFileSelction($event)"
      [accept]="allowedVideoTypes"
    />
    <img src="assets/images/upload.svg" alt="Upload" />
    <p>Drag and drop here or <span>Upload</span></p>
  </ng-container>
</ng-template>

<ng-template #progress>
  <app-circle-progress
    [progressPercentage]="loadingPercentage"
  ></app-circle-progress>
</ng-template>
